import confirm from "../components/Modals/ConfirmModal";

/**
 * @param {string} message
 * @param {AsyncFunction} perform
 * @return {Promise}
 */
export default async function confirmWith(message, perform) {
  try {
    await confirm(message);
  } catch (_) {
    // User cancelled, safe to ignore

    return null;
  }

  return await perform();
}



// WEBPACK FOOTER //
// ./app/utils/confirm-with.js